// Kent State University's undergraduate majors (#2743). Read on 2026-10-01
// from the official Kent State 2026-2027 University Catalog (catalog.kent.edu):
// its Programs finder tags every program by level and campus, and each group
// cites the catalog page of the college that offers it. Kept: every bachelor's
// program the catalog offers on the Kent Campus. Left out: minors,
// certificates, associate and graduate programs, University College's
// Exploratory Program and Cooperative Education Program (not degrees), and
// seven bachelor's programs the catalog lists only at regional campuses or
// online (among them Engineering Technology, Information Technology, Social
// Work and Technical and Applied Studies). Degree abbreviations are the
// catalog's own. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "kent-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major Kent State's 2026-2027 University Catalog offers on the Kent Campus, grouped by the college that offers it, with the degree it leads to. Minors, certificates, associate and graduate programs are left out.",
    "groups": [
        {
            "name": "Ambassador Crawford College of Business and Entrepreneurship",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, Ambassador Crawford College of Business and Entrepreneurship",
                "url": "https://catalog.kent.edu/colleges/be/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Advertising",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "General Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Hospitality and Event Management",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Sport Administration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Aeronautics and Engineering",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Aeronautics and Engineering",
                "url": "https://catalog.kent.edu/colleges/ar/"
            },
            "majors": [
                {
                    "name": "Aeronautical Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Aerospace Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Air Traffic and Airspace Management",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation Management",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Mechatronics Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechatronics Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Professional Pilot",
                    "degree": "B.S."
                },
                {
                    "name": "Unmanned Aircraft Systems Flight Operations",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Architecture and Environmental Design",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Architecture and Environmental Design",
                "url": "https://catalog.kent.edu/colleges/ae/"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of the Arts",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of the Arts",
                "url": "https://catalog.kent.edu/colleges/ca/"
            },
            "majors": [
                {
                    "name": "Animation Game Design",
                    "degree": "B.S."
                },
                {
                    "name": "Art Education",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Fashion Design",
                    "degree": "B.A."
                },
                {
                    "name": "Fashion Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Fashion Merchandising",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Design, Technology and Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Communication and Information",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Communication and Information",
                "url": "https://catalog.kent.edu/colleges/ci/"
            },
            "majors": [
                {
                    "name": "Applied Media",
                    "degree": "B.A."
                },
                {
                    "name": "Digital Media Production",
                    "degree": "B.S."
                },
                {
                    "name": "Emerging Media and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Photography",
                    "degree": "B.F.A."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.S."
                },
                {
                    "name": "User Experience Design",
                    "degree": "B.S."
                },
                {
                    "name": "Visual Communication Design",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Communication Design",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "College of Education and Human Services",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Education and Human Services",
                "url": "https://catalog.kent.edu/colleges/es/"
            },
            "majors": [
                {
                    "name": "American Sign Language/English Interpreting",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Language Arts",
                    "degree": "B.S.E."
                },
                {
                    "name": "Integrated Mathematics",
                    "degree": "B.S.E."
                },
                {
                    "name": "Integrated Science",
                    "degree": "B.S.E."
                },
                {
                    "name": "Integrated Social Studies",
                    "degree": "B.S.E."
                },
                {
                    "name": "Middle Childhood Education",
                    "degree": "B.S.E."
                },
                {
                    "name": "Physical Education, Health and Sport Exploration",
                    "degree": "B.S."
                },
                {
                    "name": "Professional Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S.E."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Nursing",
                "url": "https://catalog.kent.edu/colleges/nu/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing for Registered Nurses",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "College of Public Health and Health Sciences",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Public Health and Health Sciences",
                "url": "https://catalog.kent.edu/colleges/pb/"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Health Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Long-Term Care Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S.P.H."
                },
                {
                    "name": "Speech Pathology and Audiology",
                    "degree": "B.S."
                },
                {
                    "name": "Sport, Exercise and Performance Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Sports Medicine",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Sciences and Humanities",
            "source": {
                "label": "Kent State 2026-2027 University Catalog, College of Sciences and Humanities",
                "url": "https://catalog.kent.edu/colleges/sh/"
            },
            "majors": [
                {
                    "name": "Actuarial Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "American Sign Language",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Criminology and Justice Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Cybercriminology",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental and Conservation Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Integrative Studies",
                    "degree": "B.I.S."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Paralegal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Peace and Conflict Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Russian Literature, Culture and Translation",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Teaching English as a Second Language",
                    "degree": "B.A."
                },
                {
                    "name": "Translation",
                    "degree": "B.S."
                },
                {
                    "name": "Zoology",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
